import { fetchAPI } from './client';
import { Product } from './types';

export interface GetProductsParams {
  category?: string;
  lang?: string;
}

/**
 * 전체 제품 목록 조회
 */
export async function getProducts(params: GetProductsParams = {}): Promise<Product[]> {
  const { category, lang = 'ko' } = params;

  const queryParams = new URLSearchParams();
  if (category) queryParams.append('category', category);
  queryParams.append('lang', lang);

  const query = queryParams.toString();
  return fetchAPI<Product[]>(`/products${query ? `?${query}` : ''}`);
}

/**
 * 제품 상세 조회
 */
export async function getProductById(id: number, lang: string = 'ko'): Promise<Product> {
  return fetchAPI<Product>(`/products/${id}?lang=${lang}`);
}
